import { mutate } from 'swr';
import axios from 'axios';
import { Notistack } from '../../../../shared/components/Notistack/Notistack';
import { IMenuItemResponse, IMenuItemPayload } from './types';

const MENU_PATH = '/configuration-service/menu';

export const requestUpdateMenu = (menuData: IMenuItemPayload[]) => {
  return mutate(MENU_PATH, async () => {
    try {
      const { data: updatedMenu } = await axios.post<IMenuItemResponse[]>(MENU_PATH, menuData);

      Notistack.successMessage('Menu - Updated Successfully');

      return updatedMenu;
    } catch (err) {
      const error = err as { response: { data: { message: string } } };
      Notistack.generalError(error?.response?.data?.message);
    }
  });
};
